/*
    this object does not include the full list of shipping form field names.
*/
export const SHIPPING_FORM_FIELDS = {
  atHomeDeliveryShippingAddress: "atHomeDeliveryShippingAddress",
  shippingAddress: "shippingAddress",
  billingAddress: "billingAddress",
  billingAddressType: "billingAddressType",
  shippingMethodCode: "shippingMethodCode",
} as const;

export const ADDRESS_VALIDATION_CATEGORY = "address-validation" as const;
export const ADDRESS_VALIDATION_CODE = "INVALID_ADDRESS" as const;

export const SHORT_ADDRESS_VALIDATION_CODE = "INVALID_SA" as const;
